import React from 'react';
import Icon from '../../../components/AppIcon';

const LeaveMetricsCard = ({ title, value, subtitle, icon, trend, trendValue, colorScheme }) => {
  const getColorClasses = () => {
    switch (colorScheme) {
      case 'primary':
        return {
          bg: 'bg-primary/10',
          icon: 'var(--color-primary)',
          text: 'text-primary'
        };
      case 'success':
        return {
          bg: 'bg-success/10',
          icon: 'var(--color-success)',
          text: 'text-success'
        };
      case 'warning':
        return {
          bg: 'bg-warning/10',
          icon: 'var(--color-warning)',
          text: 'text-warning'
        };
      case 'error':
        return {
          bg: 'bg-error/10',
          icon: 'var(--color-error)',
          text: 'text-error'
        };
      default:
        return {
          bg: 'bg-muted',
          icon: 'var(--color-muted-foreground)',
          text: 'text-muted-foreground'
        };
    }
  };

  const colors = getColorClasses();

  return (
    <div className="bg-card border border-border rounded-md p-4 md:p-6 transition-smooth hover:shadow-md">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 ${colors?.bg} rounded-md`}>
          <Icon name={icon} size={20} color={colors?.icon} />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-md ${trend === 'up' ? 'bg-success/10' : 'bg-error/10'}`}>
            <Icon 
              name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
              size={14} 
              color={trend === 'up' ? 'var(--color-success)' : 'var(--color-error)'} 
            />
            <span className={`caption text-xs font-medium ${trend === 'up' ? 'text-success' : 'text-error'}`}>
              {trendValue}
            </span>
          </div>
        )}
      </div>
      <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-1 md:mb-2 data-text">
        {value}
      </h3>
      <p className="caption text-xs md:text-sm text-muted-foreground mb-1">{title}</p>
      {subtitle && (
        <p className="caption text-xs text-muted-foreground">{subtitle}</p>
      )}
    </div>
  );
};

export default LeaveMetricsCard;